import { brandFromOrderForm } from './resolvers/brand/fromOrderForm';
import { brandFromItem } from './resolvers/brand/fromItem';
import { normalizeBrand } from './utils';
import type { EventContext, EventName } from '../types';

/**
 * Determines the brand for an event by using the context or extracting it based on the event type.
 *
 * Prefers `context.brand` when present; otherwise selects a resolver based on `eventName` to extract the brand.
 *
 * @param context - The event context which may already contain a `brand` or provide data for extraction
 * @param eventName - The event name used to choose the extraction strategy
 * @returns The resolved brand value, or `null` if no brand could be determined
 */
export function getBrand(context: EventContext, eventName: EventName) {
  if (context?.brand) return normalizeBrand(context.brand);

  switch (eventName) {
    case 'CUSTOM_VIEW_CART':
    case 'ADD_COUPON':
    case 'ADD_PERSONAL_INFO':
    case 'CUSTOM_ADD_SHIPPING_INFO':
    case 'CUSTOM_ADD_PAYMENT_INFO':
    case 'BEGIN_CHECKOUT':
    case 'SEARCH_ZIPCODE':
    case 'ORDER_REVIEWED':
    case 'PURCHASE':
      return brandFromOrderForm(context);
    case 'ADD_TO_CART':
    case 'REMOVE_FROM_CART':
      return brandFromItem(context);
    default:
      return null;
  }
}
